<template>
  <div class="animated fadeIn kanban-main-container">
    <div class="w-100 px-3 kanban-nav">
      <template v-if="!isTablet">
        <h5 class="pt-md-2 pt-3">
          <span class="d-md-down-none">
            <i class="fas fa-address-card"></i> {{ boardName }}
            <i
              v-if="isReadOnly"
              class="ml-4 cursor-pointer fas fa-eye"
              v-b-tooltip.hover
              title="Este quadro está somente como leitura para mudar, altere a data limite editando o quadro na tela anterior ou Receba permissão de Edição Completa"
            ></i>
            <i class="fas fa-grip-lines-vertical ml-2 mr-2"></i>
          </span>
          <span
            class="d-sm-block d-md-none"
            style="
              font-size: 11px;
              font-weight: 600;
              display: block;
              padding-bottom: 5px;
            "
          >
            {{ boardName }}
          </span>
          <b-button
            class="btn btn-sm btn-outline-third rounded-4 d-md-down-none"
            size="sm"
            @click="onBackListBoard"
          >
            <i class="fas fa-arrow-circle-left"></i>&nbsp; Voltar
          </b-button>
          <b-button
            v-if="
              (boardColumns &&
                boardColumns.length > 0 &&
                !isTablet &&
                !board.arquivado &&
                !board.isReadOnly) ||
              (board &&
                new Date(board.dataFinal) >= new Date() &&
                board.tipoBoard === 'AJUIZAMENTO')
            "
            class="btn btn-sm btn-third rounded-4"
            size="sm"
            @click="showModalNewLead"
          >
            <i class="fas fa-user-plus"></i>
            <span class="d-md-down-none"
              >&nbsp;
              {{
                board.tipoBoard === 'AJUIZAMENTO'
                  ? 'Novo Processo'
                  : 'Nova Oportunidade'
              }}</span
            >
          </b-button>
        </h5>
        <div
          class="pt-2 d-flex justify-content-between align-items-center"
          style="position: fixed; right: 10px"
        >
          <a
            href="javascript:void(0)"
            class="pl-4 d-sm-block d-md-none"
            @click="onBackListBoard"
          >
            <i
              class="fas fa-arrow-circle-left f-18px text-third"
              v-b-tooltip.hover
              title="Voltar"
            ></i>
          </a>
          <a
            href="javascript:void(0)"
            class="pl-4"
            @click="onReloadBoard"
          >
            <i
              class="fas fa-sync-alt f-18px text-third"
              v-b-tooltip.hover
              title="Recarregar"
            ></i>
          </a>
          <a
            v-if="hasRole(roles.ADMINISTRADOR) && board && !board.arquivado"
            href="javascript:void(0)"
            class="pl-4"
            @click="onSettingsBoard"
          >
            <i
              class="fas fa-columns f-18px text-third"
              v-b-tooltip.hover
              title="Configurações das colunas"
            ></i>
          </a>
          <a
            href="javascript:void(0)"
            class="pl-4"
            @click="onShowSearch"
          >
            <i
              class="fas fa-search f-18px text-third"
              v-b-tooltip.hover
              title="Pesquisar"
            ></i>
          </a>
          <b-dropdown
            variant="link"
            no-caret
          >
            <template slot="button-content">
              <i
                class="fas fa-filter f-18px text-third"
                v-b-tooltip.hover
                title="Resultados"
              ></i>
            </template>
            <b-dropdown-item
              href="javascript:void(0)"
              @click="showLeadWon"
              ><i
                class="fa fa-user-check"
                style="color: #006a5b"
              ></i>
              Ganhos</b-dropdown-item
            >
            <b-dropdown-item
              href="javascript:void(0)"
              @click="showLeadLost"
              ><i
                class="fas fa-user-slash"
                style="color: #006a5b"
              ></i>
              Perdidos</b-dropdown-item
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              href="javascript:void(0)"
              @click="showLeadFinished"
              ><i
                class="fas fa-user-clock"
                style="color: #006a5b"
              ></i>
              Finalizados</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </template>
      <template v-else>
        <div class="d-flex align-items-center justify-content-between w-100">
          <i
            class="ml-1 cursor-pointer text-third fas fa-eye"
            v-b-tooltip.hover
            title="Este quadro está somente como leitura para mudar, altere a data limite editando o quadro na tela anterior"
          ></i>
          <div>
            <b-button
              class="btn btn-sm btn-outline-third rounded-4 mr-1"
              size="sm"
              @click="onBackListBoard"
            >
              <i class="fas fa-arrow-circle-left"></i>
              <span class="d-md-down-none">&nbsp; Voltar</span>
            </b-button>
            <b-button
              v-if="boardColumns && boardColumns.length > 0 && !board.arquivado"
              class="btn btn-sm btn-third rounded-4"
              size="sm"
              @click="showModalNewLead"
            >
              <i class="fas fa-user-plus"></i>&nbsp; Nova
              <!-- <span class="d-md-down-none">&nbsp; Nova Oportunidade</span> -->
            </b-button>
          </div>
          <div class="d-flex align-items-center">
            <a
              v-if="hasRole(roles.ADMINISTRADOR) && board && !board.arquivado"
              href="javascript:void(0)"
              class="pl-4"
              @click="onSettingsBoard"
            >
              <i
                class="fas fa-columns f-18px text-third"
                v-b-tooltip.hover
                title="Configurações das colunas"
              ></i>
            </a>
            <a
              href="javascript:void(0)"
              class="pl-4"
              @click="onShowSearch"
            >
              <i
                class="fas fa-search f-18px text-third"
                v-b-tooltip.hover
                title="Pesquisar"
              ></i>
            </a>
            <b-dropdown
              variant="link"
              no-caret
            >
              <template slot="button-content">
                <i
                  class="fas fa-filter f-18px text-third"
                  v-b-tooltip.hover
                  title="Resultados"
                ></i>
              </template>
              <b-dropdown-item
                href="javascript:void(0)"
                @click="showLeadWon"
                ><i
                  class="fa fa-user-check"
                  style="color: #006a5b"
                ></i>
                Ganhos</b-dropdown-item
              >
              <b-dropdown-item
                href="javascript:void(0)"
                @click="showLeadLost"
                ><i
                  class="fas fa-user-slash"
                  style="color: #006a5b"
                ></i>
                Perdidos</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                href="javascript:void(0)"
                @click="showLeadFinished"
                ><i
                  class="fas fa-user-clock"
                  style="color: #006a5b"
                ></i>
                Finalizados</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </template>
    </div>
    <!-- <div v-if="isTablet" class="row justify-content-center"
      style="position:fixed; top:110px; width: 98%; margin-left: 1%; z-index: 666;">
      <b-button v-if="boardColumns && boardColumns.length > 0" class="opacity-100 btn btn-sm btn-third rounded-4 w-100"
        @click="showModalNewLead">
        <i class="fas fa-user-plus"></i>&nbsp; Nova Oportunidade
      </b-button>
    </div> -->
    <div
      class="kanban-container"
      :style="isTablet ? 'position:relative; top:35px' : ''"
    >
      <div
        class="kanban-board pl-3"
        v-if="boardColumns && boardColumns.length > 0"
      >
        <!-- v-show="!showLoading" -->
        <div
          class="kanban-column"
          v-for="(column, index) in boardColumns"
          :key="column.id"
        >
          <div class="kanban-column-title justify-content-between">
            <div class="d-flex justify-content-between">
              <span class="text-left">{{ column.nome }}</span>
              <div class="text-right">
                <span
                  v-if="
                    (column.eventoColuna != 0 &&
                      column.eventoColuna.some((event) => event !== 5)) ||
                    (column.eventoColuna.some((event) => event === 5) &&
                      shouldShowIcon(column))
                  "
                >
                  <i
                    class="fas fa-bolt text-warning icone-grid pl-1"
                    style="font-size: 14px"
                    v-b-popover.hover="{
                      title: 'Eventos obrigatorios na coluna',
                      content: printEventsBoardColumn(column.eventoColuna),
                      variant: 'light',
                      html: true
                    }"
                  />
                </span>
                <!-- <span v-else><i class="fas fa-bolt icone-grid pl-1" v-b-tooltip.hover title="Não há eventos na coluna"
                      style="color: #fff; font-size: 14px;" /></span> -->
                <span v-if="column.observacao"
                  ><i
                    class="fas fa-lightbulb text-light icone-grid pl-1"
                    style="font-size: 14px"
                    v-b-popover.hover="{
                      title: 'Observação',
                      content: column.observacao,
                      variant: 'light'
                    }"
                /></span>
                <!-- <i v-if="screenW < 768" class="fas fa-info-circle pl-1" v-b-tooltip.click="column.observacao"
                  style="margin-top: 3px;"></i>
                <i v-else-if="column.observacao" class="fas fa-info-circle pl-1"
                  v-b-tooltip.hover="column.observacao ? column.observacao : 'Não há observações no momento!'"
                  style="margin-top: 3px;"></i> -->
                <b-dropdown
                  no-caret
                  variant="none"
                  toggle-class="py-0 px-1"
                >
                  <template #button-content>
                    <i
                      class="fas fa-ellipsis-h"
                      v-b-tooltip.hover
                      title="Clique para ver as Opções de Ordenação"
                      style="color: #fff; font-size: 14px"
                    ></i>
                  </template>
                  <b-dropdown-group
                    header="Ordenar Por"
                    header-variant="none"
                  >
                    <b-dropdown-item
                      v-for="sortOption in filteredSortOptions"
                      :key="sortOption.value"
                      @click="sort(column.id, sortOption.value)"
                    >
                      <i
                        v-if="sortOption.icon"
                        :class="sortOption.icon"
                      />
                      {{ sortOption.text }}
                      <i
                        v-if="isSorted(column.id, sortOption.value)"
                        class="fas fa-check text-success mx-1"
                      />
                    </b-dropdown-item>
                    <div>&nbsp;</div>
                  </b-dropdown-group>
                </b-dropdown>
              </div>
            </div>
            <div
              class="justify-content-between"
              style="color: #89dc86"
            >
              <span class="column-subtitle-details"
                >Quantidade: {{ column.totalCards }}</span
              >
              <span
                v-if="column.valorTotalProdutos > 0"
                class="column-subtitle-details pl-1"
                >{{ formatMoney(column.valorTotalProdutos) }}</span
              >
              <template>
                <span
                  v-if="column.percentual"
                  class="column-subtitle-details pl-1"
                  :class="thermometerClass(column.percentual)"
                  v-b-tooltip.hover
                  title="Percentual de fechamento"
                >
                  <i :class="thermometerIcon(column.percentual)"></i>
                  {{ column.percentual }}%
                </span>
              </template>
            </div>
          </div>
          <div
            class="autoscroll"
            ref="scrollContainer"
          >
            <div
              class="text-center mt-5 pt-5 pb-5"
              v-if="showCardLoading && showCardLoadingIndex === index"
            >
              <b-spinner
                style="width: 3rem; height: 3rem"
                class="text-third"
              ></b-spinner>
              <div class="text-third">Carregando!</div>
            </div>
            <draggable
              v-if="column"
              :list="
                column && column.cards ? column.cards : (column.cards = [])
              "
              v-on:change="onMove($event, column)"
              :animation="200"
              ghost-class="ghost-card"
              group="tasks"
              class="draggable-area"
              :class="{ 'draggable-disabled': !isDraggableEnabled }"
              :sort="filterValue === 'posicao' ? true : false"
            >
              <template
                v-if="column && column.cards && column.cards.length > 0"
              >
                <task-card
                  v-for="(card, index) in column.cards"
                  :key="card.id"
                  :task="card"
                  :color="column.cor"
                  :boardColumnId="column.id"
                  :boardPosition="column.position ? column.position : 0"
                  :hoursUntilAlert="column.hoursUntilAlert"
                  :index="index"
                  :hasObservation="
                    card.observacao !== null && card.observacao !== undefined
                  "
                  v-on:Open="showLead(card)"
                ></task-card>
              </template>
              <b-skeleton-wrapper :loading="!showLoading">
                <template v-if="showLoading">
                  <b-card
                    v-for="index in 5"
                    :key="index"
                    style="
                      border-left: solid #2e6e60 3px;
                      background-color: #f1f1f2;
                    "
                  >
                    <div
                      class="d-flex align-items-center justify-content-between mb-3"
                    >
                      <b-skeleton
                        width="60%"
                        height="50%"
                      ></b-skeleton>
                      <b-skeleton
                        width="2.5rem"
                        height="2.5rem"
                        type="avatar"
                      ></b-skeleton>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <b-skeleton
                        class="mr-2"
                        width="20%"
                      ></b-skeleton>
                      <b-skeleton width="80%"></b-skeleton>
                    </div>
                  </b-card>
                </template>
              </b-skeleton-wrapper>
            </draggable>
          </div>
        </div>
      </div>
      <div
        class="kanban-board pl-3"
        v-if="!showLoading && (!boardColumns || boardColumns.length === 0)"
      >
        <div
          class="pr-3 w-100"
          v-if="hasRole(roles.ADMINISTRADOR)"
        >
          <div
            class="mt-5 text-center cursor-pointer"
            style="border: dashed 2px #ccc; padding: 100px; font-size: 32px"
            @click="onSettingsBoard"
          >
            <i
              class="fas fa-columns"
              v-b-tooltip.hover
              title="Configurações das colunas"
            ></i>
            Clique para adicionar colunas!
          </div>
        </div>
        <div
          class="pr-3 w-100"
          v-else
        >
          <div
            class="mt-5 text-center"
            style="padding: 100px; font-size: 32px"
          >
            <i
              class="fas fa-columns"
              v-b-tooltip.hover
              title="Nao possui coluna"
            ></i>
            Não possui nenhuma coluna!
          </div>
        </div>
      </div>
    </div>
    <ModalCard
      ref="ModalCard"
      v-if="selectedCard"
      @hideModal="hideLead"
      :key="selectedCard"
      :board="board ? board : null"
      @reloadBoardColumns="reloadBoardColumns"
      :boardColumns="boardColumns"
      :cardId="selectedCard"
    />
    <BoardCollumns
      ref="BoardCollumns"
      :board="board ? board : null"
      :boardColumns="allBoardColumns ? allBoardColumns : []"
      v-on:ReloadColumns="onReloadBoard"
      v-on:Back="onReloadBoard"
    />
    <NewLeadModal
      ref="NewLeadModal"
      v-if="modalNewLeadOpen"
      @closeModal="closeModalNewLead"
      :board="board ? board : null"
      :boardColumns="boardColumns ? boardColumns : []"
      v-on:Back="onReloadBoard"
    />
    <!-- <FollowUpEvent ref="FollowUpEvent" /> -->
    <SidebarSearch
      v-if="board"
      :board="board"
      @search="onSearch"
    />
    <EventManager
      v-if="
        draggedCard && columnEvents && !board.arquivado && !board.isReadOnly
      "
      :key="draggedCard.id"
      ref="EventManager"
      :eventsToShow="columnEvents"
      :card="draggedCard"
      :colunaDestino="colunaDestino"
      @Submited="submitedEvents"
      @Aborted="abortedEvents"
    >
    </EventManager>

    <b-modal
      @close="closeConfirmationReadOnlyModal"
      @hide="closeConfirmationReadOnlyModal"
      ref="read-only-modal"
      scrollable
      centered
    >
      <template #modal-title>
        <i class="fas fa-exclamation-triangle"></i> Quadro somente leitura
      </template>
      <div class="col-md-12">
        <p>
          Este quadro está somente como leitura, não sendo possível a edição do
          mesmo
        </p>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <b-button
            class="btn btn-sm btn-third rounded-4 ml-2"
            size="sm"
            @click.prevent="closeConfirmationReadOnlyModal"
          >
            <i class="fas fa-check-circle"></i
            ><span class="d-md-down-none">&nbsp; Confirmar</span>
          </b-button>
        </div>
      </template>
    </b-modal>
    <div v-if="isMobile">
      <NxDraggableButtonCrm
        :onClick="toggleDraggable"
        :iconClass="isDraggableEnabled ? 'fas fa-lock-open' : 'fas fa-lock'"
        @update:buttonPosition="updateButtonPosition"
        :buttonPosition="buttonPosition"
        :title="
          isDraggableEnabled ? 'Arrastar desabilitado' : 'Arrastar habilitado'
        "
      />
    </div>
  </div>
</template>

<script>
import NxDraggableButtonCrm from '@/components/nexum/components/buttons/NxDraggableButtonCrm.vue'
import Tools from '@/components/tools/Tools.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import EventManager from '@/views/private/crm/board/modal/event/EventManager.vue'
import TaskCard from '@/views/private/crm/components/TaskCard.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import Draggable from 'vuedraggable'
import BoardCollumns from './modal/collumns/boardcollumns.vue'
import FollowUpEvent from './modal/event/followupevent.vue'
import NewLeadModal from './modal/new/newlead.vue'

import BoardRepository from '@/shared/http/repositories/crm/board.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { useScrollListenerMixin } from '@/shared/mixins/useScrollListenerMixin.js'

import SidebarSearch from '@/views/private/crm/board/search/SidebarQuadro.vue'

import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'

const PATH_URL_API = process.env.APIBaseURLCore

const cardDataModel = {
  boardColumnId: null,
  motivoPerdaId: null,
  origemLeadId: null,
  pessoaId: null,
  posicao: 0,
  situacao: 0,
  countReativado: null,
  dataCriacao: null,
  dataInicioSituacao: null,
  dataReativacao: null
}

const scrollListenerMixin = useScrollListenerMixin(
  'scrollContainer',
  {
    scrollUp: 'handleScrollUp',
    scrollDown: 'handleScrollDown'
  },
  false
)

export default {
  name: 'Board',
  mixins: [ActionsForm, scrollListenerMixin],
  data () {
    return {
      data: cardDataModel,
      showCardModal: false,
      modalNewLeadOpen: false,
      selectedCard: null,
      draggedCard: null,
      draggedPath: null,
      columnEvents: null,
      showLoading: true,
      showCardLoading: false,
      showCardLoadingIndex: null,
      board: null,
      boardColumns: [],
      allBoardColumns: [],
      paginasColunas: [],
      page: 0,
      size: 10,
      totalPages: 0,
      filterValue: 'posicao',
      isTablet: screen.width <= 768,
      filters: '',
      sortOptions: [
        {
          value: 'posicao,asc',
          text: 'Padrão',
          icon: 'fas fa-sort-amount-down-alt forceTextThird'
        },
        {
          value: 'pessoa.nome,asc',
          text: 'Nome (em ordem alfabética)',
          icon: 'fas fa-sort-alpha-down forceTextThird'
        },
        // { value: 'followUp.data,desc', text: 'Ultimo FollowUp', icon: 'fas fa-comments forceTextThird' }, TEMPORARIAMENTE COMENTADO PRA REFATORAR ORDENACAO
        // { value: 'produto.valor,desc', text: 'Valor (maior para o menor)', icon: 'fas fa-sort-numeric-down-alt forceTextThird' }, TEMPORARIAMENTE COMENTADO PRA REFATORAR ORDENACAO
        {
          value: 'dataCriacao,desc',
          text: 'Data Abertura (mais recente primeiro)',
          default: true,
          icon: 'fas fa-calendar-plus forceTextThird'
        },
        {
          value: 'dataCriacao,asc',
          text: 'Data Abertura (mais antigo primeiro)',
          icon: 'fas fa-calendar-check forceTextThird'
        },
        {
          value: 'cardDetails.agendamento,desc',
          text: 'Próximo agendamento (mais longe primeiro)',
          icon: 'fas fa-calendar-day forceTextThird'
        },
        {
          value: 'cardDetails.agendamento,asc',
          text: 'Próximo agendamento (mais perto primeiro)',
          icon: 'fas fa-calendar-minus forceTextThird'
        },
        {
          value: 'produto.diasAtraso,desc',
          text: 'Dias em atraso (maior inadimplência)',
          icon: 'fas fa-calendar-plus forceTextThird'
        },
        {
          value: 'produto.diasAtraso,asc',
          text: 'Dias em atraso (menos inadimplência)',
          icon: 'fas fa-calendar-minus forceTextThird'
        }
      ],
      sorts: [],
      colunaDestino: null,
      readOnlyAlertViewd: false,
      isDraggableEnabled: true,
      buttonPosition: {
        top: 120,
        left: 350
      },
      hasPosicaoCardsKanban: process.env.hasPosicaoCardsKanban
    }
  },
  components: {
    BoardCollumns,
    NewLeadModal,
    FollowUpEvent,
    Draggable,
    TaskCard,
    ModalCard,
    EventManager,
    SidebarSearch,
    AddConfirmation,
    NxDraggableButtonCrm
  },
  computed: {
    boardId: function () {
      return this.$route.params.boardId
    },
    backUrl: function () {
      return this.$route.params.backUrl
    },
    boardName () {
      let result = ''
      if (this.board) {
        result = this.board.nome
      }
      return result
    },
    isReadOnly () {
      if (this.board && this.board.isReadOnly) {
        this.openConfirmationReadOnlyModal()
        return true
      }
      return false
    },
    isMobile () {
      return window.innerWidth <= 768
    },
    filteredSortOptions () {
      return this.hasPosicaoCardsKanban
        ? this.sortOptions.filter(option => option.value !== 'posicao,asc')
        : this.sortOptions
    }
  },
  methods: {
    consolelog (data) {
      console.log(data)
    },
    shouldShowIcon (column) {
      return (
        Array.isArray(column.eventoColuna) &&
        column.eventoColuna.some((event) => event === 5) &&
        ((Array.isArray(column.movimentacaoAutoAtrasoProduto)
          ? column.movimentacaoAutoAtrasoProduto.length > 0 &&
            column.movimentacaoAutoAtrasoProduto.some(
              (event) => event.inative !== true
            )
          : column.movimentacaoAutoAtrasoProduto &&
            column.movimentacaoAutoAtrasoProduto !== null &&
            typeof column.movimentacaoAutoAtrasoProduto === 'object' &&
            column.movimentacaoAutoAtrasoProduto.inative !== true) ||
          (Array.isArray(column.movimentacaoAutoDiaProduto)
            ? column.movimentacaoAutoDiaProduto.length > 0 &&
              column.movimentacaoAutoDiaProduto.some(
                (event) => event.inative !== true
              )
            : column.movimentacaoAutoDiaProduto &&
              column.movimentacaoAutoDiaProduto !== null &&
              typeof column.movimentacaoAutoDiaProduto === 'object' &&
              column.movimentacaoAutoDiaProduto.inative !== true) ||
          (column.movimentacaoAutoTempoBoardColumn &&
            (Array.isArray(column.movimentacaoAutoTempoBoardColumn)
              ? column.movimentacaoAutoTempoBoardColumn.length > 0 &&
                column.movimentacaoAutoTempoBoardColumn.some(
                  (event) => event.inative !== true
                )
              : column.movimentacaoAutoTempoBoardColumn !== null &&
                typeof column.movimentacaoAutoTempoBoardColumn === 'object' &&
                column.movimentacaoAutoTempoBoardColumn.inative !== true)))
      )
    },
    async onLoad () {
      loading.push()
      this.showLoading = true
      this.boardColumns = []
      await this.onLoadBoard()

      if (this.board) {
        await this.onLoadBoardColumn()
        await this.onLoadCards()
      } else {
        this.showLoading = false
        loading.pop()
      }
    },
    async handleScrollUp (event, index) {},
    async handleScrollDown (event, index) {
      if (this.boardColumns[index].isLoading) return

      this.boardColumns[index].isLoading = true

      this.boardColumns[index].page++

      try {
        await this.onLoadBoardColumnCards(this.boardColumns[index], index)
      } catch (error) {
        console.error('Erro ao carregar os cards:', error)
      } finally {
        this.boardColumns[index].isLoading = false
        this.showCardLoading = false
        this.showLoading = false
        this.showCardLoadingIndex = null
        loading.length = 0
      }
    },
    showModalNewLead () {
      this.modalNewLeadOpen = true
    },
    closeModalNewLead () {
      this.modalNewLeadOpen = false
    },
    downloadReport () {
      if (this.boardId) {
        toast.info('Seu download está em progresso, por favor aguarde!')
        BoardRepository.Report(this.boardId)
          .then((response) => {
            loading.close()
            if (response.status === 200) {
              toast.success('Relatório gerado com sucesso!')
              let data = response.data
              if (data && data.uuid) {
                window.open(
                  `${PATH_URL_API}/arquivos/compartilhados/${data.uuid}/download`
                )
              }
            }
          })
          .catch(() => {
            toast.error(
              'Pedimos desculpas, <br> Houve um erro ao gerar o relatório.<br> Tente novamente mais tarde. <br><br>Caso persista, entre em contato com o administrador do sistema.'
            )
          })
      }
    },
    onReloadBoard () {
      this.onLoad()
    },
    onBackListBoard () {
      this.board.tipoBoard === 'AJUIZAMENTO'
        ? this.$router.push({
          name: 'CRMModular',
          params: {
            tipoQuadro: 'ajuizamento'
          }
        })
        : this.board.tipoBoard === 'COBRANCA'
          ? this.$router.push({
            name: 'CRMModular',
            params: {
              tipoQuadro: 'cobranca'
            }
          })
          : this.$router.push({
            name: 'CRMModular'
          })
    },

    onSettingsBoard () {
      this.$refs.BoardCollumns.showModal()
    },
    async onLoadBoard () {
      if (this.boardId) {
        await BoardRepository.Board_GetById(this.boardId)
          .then((response) => {
            if (response.status === 200) {
              this.board = response.data
            }
          })
          .catch((e) => {
            console.error(e.message)
          })
      }
    },
    async onLoadBoardColumn () {
      if (this.boardId) {
        if (this.boardColumns !== null && this.boardColumns.length > 0) {
          this.removeScrollContainerScrollListener()
        }

        this.totalPages = []
        const defaultSort = this.sortOptions.find((sort) => sort.default)

        this.allBoardColumns = []
        await BoardRepositoryV2.Column_GetAll(this.boardId)
          .then((response) => {
            if (response.status === 200) {
              var data = response.data
              let columns = data.content

              columns.sort((a, b) => {
                return a.posicao - b.posicao
              })

              columns.forEach((element) => {
                let column = element
                column.cards = []
                column.mnemonic = null
                this.allBoardColumns.push(column)
                this.addOrUpdateSort(column.id, defaultSort.value)
              })

              if (this.boardColumns.length === 0) {
                this.showLoading = false
                loading.pop()
              }
            }
          })
          .catch((e) => {
            console.error(e.message)
          })

        this.boardColumns = []
        await BoardRepositoryV2.Column_GetAllActive(this.boardId)
          .then((response) => {
            if (response.status === 200) {
              var data = response.data
              let columns = data.content

              columns.sort((a, b) => {
                return a.posicao - b.posicao
              })

              columns.forEach((element) => {
                let column = element
                column.cards = []
                column.mnemonic = null
                column.page = 0
                this.boardColumns.push(column)
                this.addOrUpdateSort(column.id, defaultSort.value)
              })

              this.addScrollContainerScrollListener()

              if (this.boardColumns.length === 0) {
                this.showLoading = false
                loading.pop()
              }
            }
          })
          .catch((e) => {
            console.error(e.message)
          })
      }
    },
    async onReloadBoardColumnCards (boardColumnId) {
      const boardColumnIndex = this.boardColumns.findIndex(
        (boardColumn) => boardColumn.id === boardColumnId
      )
      const boardColumn = this.boardColumns[boardColumnIndex]
      const boardColumnElement = this.$refs.scrollContainer[boardColumnIndex]

      boardColumn.cards = []
      boardColumn.page = 0
      boardColumnElement.scrollTop = 0

      loading.push()
      this.showCardLoadingIndex = boardColumnIndex
      this.showCardLoading = true

      await this.onLoadBoardColumnCards(boardColumn, boardColumnIndex)
    },
    async onLoadCards () {
      this.boardColumns.forEach((boardColumn, index) => {
        this.onLoadBoardColumnCards(boardColumn, index)
      })
    },
    async onLoadBoardColumnCards (boardColumn, index) {
      try {
        const boardIsFiled = boardColumn.board.arquivado || false
        const situacao = 'ATIVO'
        const sort = this.sorts.find(
          (sort) => sort.boardColumnId === boardColumn.id
        )
        const response = await BoardRepositoryV2.Card_GetAllByPaging(
          boardColumn.board.id,
          boardColumn.id,
          boardIsFiled,
          situacao,
          this.filters,
          this.size,
          boardColumn.page,
          sort.value
        )

        if (response.status === 200) {
          const data = response.data
          if (data) {
            this.updateCards(data, index)
          }
        }

        this.handleLoading(index)
      } catch (e) {
        console.error(e.message)
        this.showLoading = false
      } finally {
        loading.pop()
      }
    },
    updateCards (data, index) {
      data.cards.content.forEach((element) => {
        const card = element
        const cardIndex = this.boardColumns[index].cards.findIndex(
          (existingCard) => existingCard.id === card.id
        )

        if (cardIndex !== -1) {
          // If a card with the same id exists, replace it
          this.boardColumns[index].cards[cardIndex] = card
        } else {
          // If no matching card is found, push the new card
          this.boardColumns[index].cards.push(card)
        }
      })

      this.boardColumns[index].valorTotalProdutos = data.valorTotalProdutos
      this.boardColumns[index].totalCards = data.totalCards
    },
    handleLoading (index) {
      if (this.boardColumns.length > 0) {
        if (this.boardColumns.length - 1 === index) {
          this.showLoading = false
          loading.pop()
        }
        this.$nextTick(() => {
          this.showCardLoading = false
          this.showCardLoadingIndex = null
          loading.pop()
        })
      }
    },
    findColumnIndex (columnId) {
      return this.boardColumns.findIndex((c) => c.id === columnId)
    },
    findCard (columnIndex, cardId) {
      return this.boardColumns[columnIndex].cards.find((c) => c.id === cardId)
    },
    onMove (event, column) {
      const { added, moved } = event
      const columnIndex = this.findColumnIndex(column.id)

      if (added && columnIndex >= 0) {
        const card = this.findCard(columnIndex, added.element.id)
        this.handleAddedEvent(card, column, added, columnIndex)
      } else if (moved && columnIndex >= 0) {
        const card = this.findCard(columnIndex, moved.element.id)
        this.handleMovedEvent(card, column, moved, columnIndex)
      }
    },
    handleAddedEvent (card, column, added, columnIndex) {
      const oldColumnId = card.boardColumn.id
      const cardIndex = this.boardColumns[columnIndex].cards.findIndex(
        (c) => c.id === added.element.id
      )

      if (cardIndex >= 0) {
        card.cardDetails.ultimoFollowup = new Date()
        this.boardColumns[columnIndex].valorTotalProdutos +=
          card.valorTotalProdutos
        this.boardColumns[card.boardColumn.posicao].valorTotalProdutos -=
          card.valorTotalProdutos
        card.boardColumn.posicao = columnIndex

        if (!column.eventoColuna.some((event) => event === 0)) {
          this.draggedCard = card
          this.columnEvents = column.eventoColuna
          this.colunaDestino = column
        } else {
          this.onMoveCard(card, column.id, added.newIndex)
        }
      }

      this.draggedPath = {
        from: oldColumnId,
        to: column.id,
        'index:': added.newIndex,
        card: card
      }
    },
    handleMovedEvent (card, column, moved, columnIndex) {
      const cardIndex = this.boardColumns[columnIndex].cards.findIndex(
        (c) => c.id === moved.element.id
      )

      if (cardIndex >= 0) {
        this.onMoveCard(card, column.id, moved.newIndex)
      }
    },
    submitedEvents () {
      this.onMoveCard(
        this.draggedPath.card,
        this.draggedPath.to,
        this.draggedPath.index
      )
      this.resetDraggedCard()
      toast.success('Ações realizadas com sucesso!', 'Sucesso')
    },
    abortedEvents () {
      this.onReloadBoardColumnCards(this.draggedPath.from)
      this.onReloadBoardColumnCards(this.draggedPath.to)
      this.resetDraggedCard()
      toast.warning(
        'Nenhuma ação foi registrada, e a oportunidade não foi movida',
        'Atenção'
      )
    },
    resetDraggedCard () {
      this.draggedCard = null
      this.columnEvents = null
      this.draggedPath = null
    },
    onLoadCardSyncDb (card, newIndex) {
      if (card) {
        this.data.id = card.id
        this.data.boardColumnId = card.boardColumn ? card.boardColumn.id : null
        this.data.motivoPerdaId = card.motivoPerda ? card.motivoPerda.id : null
        this.data.posicao = newIndex
        this.data.situacao = card.situacao
        this.data.countReativado = card.countReativado
        this.data.dataCriacao = card.dataCriacao
        this.data.dataInicioSituacao = card.dataInicioSituacao
        this.data.dataReativacao = card.dataReativacao
        this.data.origemLeadId = card.origemLead ? card.origemLead.id : null
        this.data.pessoaId = card.pessoa ? card.pessoa.id : null
      }
    },
    onMoveCard (card, newBoardColumnId, newIndex) {
      if (this.board.arquivado || this.board.isReadOnly || card.readOnly) return
      if (!this.verifyRequiredColumns(card.boardColumn.id, newBoardColumnId)) {
        return
      }
      if (card) {
        let moveCardData = {
          id: card.id,
          newPosition: newIndex,
          newColumn: newBoardColumnId
        }
        loading.push()
        const oldBoardColumnId = card.boardColumn.id
        this.onLoadCardSyncDb(card, newIndex)
        this.data.boardColumnId = newBoardColumnId
        this.data.dataInicioSituacao = new Date().toISOString()
        BoardRepositoryV2.Card_MoveCardColumns(
          card.boardColumn.board.id,
          card.boardColumn.id,
          card.id,
          moveCardData
        )
          .then((response) => {
            loading.pop()
            card.boardColumn.id = newBoardColumnId
            this.$nextTick(() => {
              this.onReloadBoardColumnCards(newBoardColumnId)
              this.onReloadBoardColumnCards(oldBoardColumnId)
            })
          })
          .catch(this.onException)
      }
    },
    verifyRequiredColumns (oldBoardColumnId, newBoardColumnId) {
      let newBoardColumnIndex = this.boardColumns.findIndex(
        (c) => c.id === newBoardColumnId
      )
      let oldBoardColumnIndex = this.boardColumns.findIndex(
        (c) => c.id === oldBoardColumnId
      )

      if (
        newBoardColumnIndex > oldBoardColumnIndex &&
        newBoardColumnIndex - oldBoardColumnIndex > 1
      ) {
        for (let i = oldBoardColumnIndex + 1; i < newBoardColumnIndex; i++) {
          let passedBoardColumn = this.boardColumns[i]

          if (passedBoardColumn.obrigatorio === true) {
            toast.warning(
              `A passagem pela coluna ${passedBoardColumn.nome} é obrigatória!`
            )
            this.onReloadBoard()
            return false
          }
        }
      }

      return true
    },
    showLead (card) {
      this.selectedCard = card.id
    },
    hideLead () {
      this.selectedCard = null
    },
    showLeadLost (cardId) {
      if (cardId) {
        this.$router.push({
          name: 'CardPerdido',
          params: {
            boardId: this.boardId,
            cardId: cardId,
            backUrl: 'Quadro'
          }
        })
      }
    },
    showLeadFinished () {
      this.$router.push({
        name: 'CardFinalizado',
        params: {
          boardId: this.boardId,
          backUrl: 'Quadro'
        }
      })
    },
    showLeadWon (cardId) {
      if (cardId) {
        this.$router.push({
          name: 'CardGanho',
          params: {
            boardId: this.boardId,
            cardId: cardId,
            backUrl: 'Quadro'
          }
        })
      }
    },
    changeFilter () {
      if (this.filterValue === 'posicao') {
        this.filterValue = 'cardDetails.ultimoFollowup,asc'
      } else {
        this.filterValue = 'posicao'
      }
      this.onReloadBoard()
    },
    formatMoney (valorTotalProdutos) {
      let result = 'R$ 0,00'
      if (valorTotalProdutos) {
        result = Tools.formatMoneyBR(valorTotalProdutos.toString())
      }
      return result
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onSearch (filters) {
      if (filters) {
        this.filters = Object.entries(filters)
          .filter(([key, value]) => value)
          .map(([key, value]) => `&${key}=${value}`)
          .join('')
      }
      this.onReloadBoard()
    },
    isSorted (boardColumnId, sort) {
      return (
        this.sorts.findIndex(
          (sortedValue) =>
            sortedValue.boardColumnId === boardColumnId &&
            sortedValue.value === sort
        ) >= 0
      )
    },
    sort (boardColumnId, sort) {
      this.addOrUpdateSort(boardColumnId, sort)
      this.onReloadBoardColumnCards(boardColumnId)
    },
    addOrUpdateSort (boardColumnId, sort) {
      const sortIndex = this.sorts.findIndex(
        (sortedValue) => sortedValue.boardColumnId === boardColumnId
      )

      if (sortIndex >= 0) {
        this.sorts[sortIndex].value = sort
      } else {
        this.sorts.push({
          boardColumnId,
          value: sort
        })
      }
    },
    reloadBoardColumns (boardColumnIds) {
      boardColumnIds.forEach((id) => {
        this.onReloadBoardColumnCards(id)
      })
    },
    printEventsBoardColumn (events) {
      const sentences = [
        { event: 1, sentence: '- Lançamento de Follow-Up' },
        { event: 2, sentence: '- Adicionar Produto' },
        { event: 3, sentence: '- Atribuir Responsavel' },
        { event: 4, sentence: '- Pesquisa Automatica Serasa' },
        { event: 5, sentence: '- Movimentação Automatica de Coluna' },
        { event: 6, sentence: '- Notificar Usuarios' },
        { event: 7, sentence: '- Envio de WhatsApp' },
        { event: 8, sentence: '- Bloquear Ajuizamento' }
      ]

      const messageParts = sentences
        .filter(({ event }) => events.includes(event))
        .map(({ sentence }) => sentence)

      const message = messageParts.join('<br>')

      return message
    },
    thermometerClass (percentual) {
      if (percentual < 50) {
        return 'text-danger'
      } else if (percentual < 75) {
        return 'text-warning'
      } else {
        return ''
      }
    },
    thermometerIcon (percentual) {
      if (percentual < 25) {
        return 'fas fa-thermometer-empty'
      } else if (percentual < 50) {
        return 'fas fa-thermometer-quarter'
      } else if (percentual < 75) {
        return 'fas fa-thermometer-half'
      } else {
        return 'fas fa-thermometer-three-quarters'
      }
    },
    openConfirmationReadOnlyModal () {
      this.$nextTick(() => {
        if (!this.readOnlyAlertViewd) {
          this.$refs['read-only-modal'].show()
        }
      })
    },
    closeConfirmationReadOnlyModal () {
      this.$nextTick(() => {
        this.$refs['read-only-modal'].hide()
        this.readOnlyAlertViewd = true
      })
    },

    toggleDraggable () {
      this.isDraggableEnabled = !this.isDraggableEnabled
    },
    updateButtonPosition (newPosition) {
      this.buttonPosition = newPosition
    }
  }
}
</script>

<style lang="scss">
footer.app-footer {
  display: none !important;
}

.aside-menu {
  position: fixed;
  right: 0;
  height: 100%;

  overflow-y: scroll;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.aside-menu::-webkit-scrollbar {
  display: none;
}
</style>

<style scoped>
.column-width {
  min-width: 320px;
  width: 315px;
}

.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}

.f-18px {
  font-size: 18px;
}

.board-reload {
  display: block;
  position: fixed;
  bottom: 5px;
  height: 35px;
  width: 40%;
  left: 46.3%;
  font-size: 20px;
}

.board-result {
  display: block;
  position: fixed;
  bottom: 0px;
  border: solid 1px #ccc;
  background-color: #ccc;
  height: 35px;
  width: 40%;
  left: 30%;
  font-size: 20px;
  /*
    left: 99%;
    position: absolute;
    transform: translateX(-50%);
    border: solid 1px #ccc;
    background-color: #ccc;
    height: 100%;
    width: 3%;
    font-size: 18px;
    */
}

.board-result-sucess {
  border: solid 1px #28a745;
  background-color: #28a745;
  color: #fff;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  height: 100%;
  /*
    width: 100%;
    border: solid 1px #28a745;
    background-color: #28a745;
    height: 50%;
    color: #fff;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    */
}

.board-result-lost {
  width: 50%;
  height: 100%;
  border: solid 1px #ff0000;
  background-color: #ff0000;
  color: #fff;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  float: left;
  /*
    width: 100%;
    border: solid 1px #ff0000;
    background-color: #ff0000;
    height: 50%;
    color: #fff;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    */
}

.column-subtitle-details {
  font-size: 11px;
  margin-top: 3px;
}

.card-empty {
  text-align: center;
  border: dotted 1px #c1c1c1;
  padding: 40px;
  border-radius: 7px;
  margin-top: 14px;
}

.autoscroll::-webkit-scrollbar-thumb {
  background: #2e6e60b3;
  border-radius: 3px;
}

.autoscroll::-webkit-scrollbar-thumb:hover {
  background: #2e6e60;
  border-radius: 3px;
}

.autoscroll {
  height: 64vh;
  height: calc(100% - 4rem);
  border-radius: 0 0.25rem 0.25rem 0;
  overflow: auto;
  padding-right: 0.3rem;
  scrollbar-width: unset; /* Para Firefox */
  scrollbar-color: #2e6e60 transparent; /* Para Firefox */
}

.btn-none {
  background: transparent;
}

.forceTextThird {
  color: #006a5b !important;
}
@media (max-width: 768px) {
  .autoscroll::-webkit-scrollbar {
    width: 12px; /* Largura da barra de rolagem em dispositivos móveis */
    height: 12px;
  }

  .autoscroll::-webkit-scrollbar-thumb {
    background: #2e6e60;
    border-radius: 12px;
  }

  .autoscroll::-webkit-scrollbar-thumb:hover {
    background: #1e4e40;
    border-radius: 12px;
  }

  .autoscroll::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 12px;
  }

  .autoscroll {
    scrollbar-width: unset; /* Para Firefox */
    scrollbar-color: #2e6e60 transparent; /* Para Firefox */
  }
  .floating-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
  }

  .draggable-disabled {
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/board.vue